import axios from "axios";

// Create an Axios instance
const apiClient = axios.create({
  baseURL:
    "https://xaa2zdc08g.execute-api.ap-southeast-2.amazonaws.com/default/",
  timeout: 8000,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    try {
      const storedData = localStorage.getItem("okta-token-storage");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        const accessToken = parsedData?.accessToken?.value;

        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
      }
    } catch (error) {
      console.error("Error reading access token from localStorage:", error);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: Global response handler
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error("API Error:", error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default apiClient;
